import React, { useState } from "react";

export default function BinaryColoringGame() {
  const decimalNumbers = [
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
  ];

  const scenes = {
    car: [
      { type: "rect", props: { x: 50, y: 100, width: 100, height: 40 }, binary: "001" },
      { type: "circle", props: { cx: 70, cy: 150, r: 15 }, binary: "010" },
      { type: "circle", props: { cx: 130, cy: 150, r: 15 }, binary: "011" },
      { type: "rect", props: { x: 80, y: 70, width: 40, height: 30 }, binary: "100" },
    ],
    cat: [
      { type: "circle", props: { cx: 100, cy: 100, r: 40 }, binary: "001" },
      { type: "circle", props: { cx: 70, cy: 160, r: 30 }, binary: "010" },
      { type: "circle", props: { cx: 130, cy: 160, r: 30 }, binary: "011" },
      { type: "polygon", props: { points: "70,60 80,30 90,60" }, binary: "100" },
      { type: "polygon", props: { points: "110,60 120,30 130,60" }, binary: "101" },
    ],
    tree: [
      { type: "rect", props: { x: 90, y: 120, width: 20, height: 60 }, binary: "001" },
      { type: "circle", props: { cx: 100, cy: 100, r: 40 }, binary: "010" },
      { type: "circle", props: { cx: 80, cy: 70, r: 20 }, binary: "011" },
      { type: "circle", props: { cx: 120, cy: 70, r: 20 }, binary: "100" },
    ],
  };

  const sceneKeys = Object.keys(scenes);

  const [currentSceneIdx, setCurrentSceneIdx] = useState(0);
  const [dragged, setDragged] = useState(null);
  const [filled, setFilled] = useState({});

  const currentScene = scenes[sceneKeys[currentSceneIdx]];

  const handleDrop = (e, binary, idx) => {
    e.preventDefault();
    if (!dragged) return;

    const decimal = parseInt(dragged.dataset.value, 10);
    const decimalBinary = decimal.toString(2).padStart(binary.length, "0");

    if (decimalBinary === binary) {
      setFilled((prev) => ({ ...prev, [idx]: true }));
      dragged.style.display = "none";
    } else {
      alert("Try Again!");
    }
  };

  const handleNextImage = () => {
    setCurrentSceneIdx((prev) => (prev + 1) % sceneKeys.length);
    setFilled({});
    // Reset all decimal numbers
    const numbers = document.querySelectorAll(".decimal-number");
    numbers.forEach((n) => (n.style.display = "inline-block"));
  };

  return (
    <div
      style={{
        fontFamily: "Comic Sans MS, Arial",
        background: "#f0f8ff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 20,
      }}
    >
      <h2 style={{ marginTop: 20 }}>🎨 Binary Colouring Game for Kids</h2>
      <p style={{ textAlign: "center", maxWidth: 400 }}>
        Drag the decimal numbers to the correct binary section of the picture!
      </p>

      {/* Numbers to drag */}
      <div
        id="numbers"
        style={{ display: "flex", justifyContent: "center", margin: "15px 0", flexWrap: "wrap" }}
      >
        {decimalNumbers.map((num, idx) => (
          <div
            key={idx}
            className="decimal-number"
            draggable
            data-value={num.value}
            onDragStart={(e) => setDragged(e.target)}
            onDragEnd={() => setDragged(null)}
            style={{
              display: "inline-block",
              padding: "10px",
              margin: "5px",
              background: "#ffd700",
              cursor: "grab",
              fontWeight: "bold",
              borderRadius: "5px",
              boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            {num.value}
          </div>
        ))}
      </div>

      {/* SVG Object */}
      <svg
        viewBox="0 0 200 200"
        style={{
          width: 300,
          height: 300,
          marginTop: 20,
          border: "2px solid #ccc",
          background: "#fff",
        }}
      >
        {currentScene.map((sec, idx) => (
          <g key={idx}>
            {sec.type === "rect" && (
              <rect
                {...sec.props}
                style={{
                  stroke: "#000",
                  strokeWidth: 2,
                  fill: filled[idx] ? "lightgreen" : "white",
                  cursor: "pointer",
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleDrop(e, sec.binary, idx)}
              />
            )}
            {sec.type === "circle" && (
              <circle
                {...sec.props}
                style={{
                  stroke: "#000",
                  strokeWidth: 2,
                  fill: filled[idx] ? "lightblue" : "white",
                  cursor: "pointer",
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleDrop(e, sec.binary, idx)}
              />
            )}
            {sec.type === "polygon" && (
              <polygon
                {...sec.props}
                style={{
                  stroke: "#000",
                  strokeWidth: 2,
                  fill: filled[idx] ? "pink" : "white",
                  cursor: "pointer",
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleDrop(e, sec.binary, idx)}
              />
            )}
            <text
              x={
                sec.type === "circle"
                  ? sec.props.cx
                  : sec.type === "rect"
                  ? sec.props.x + sec.props.width / 2
                  : 100
              }
              y={
                sec.type === "circle"
                  ? sec.props.cy + 5
                  : sec.type === "rect"
                  ? sec.props.y + sec.props.height / 2 + 5
                  : 60
              }
              textAnchor="middle"
              style={{ fontSize: 10, fontWeight: "bold", fill: "black", pointerEvents: "none" }}
            >
              {sec.binary}
            </text>
          </g>
        ))}
      </svg>

      <button
        onClick={handleNextImage}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          fontSize: 16,
          borderRadius: 8,
          cursor: "pointer",
          background: "#87ceeb",
          color: "#fff",
          border: "none",
        }}
      >
        Next Image
      </button>
    </div>
  );
}
